/**
 * Remove acentos de uma string
 */
function removeAccents(str: string): string {
  return str
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}

/**
 * Gera um nome de usuário a partir do nome e sobrenome
 * Exemplo: "João Silva" → "joao.silva"
 */
export function generateUsername(firstName: string, lastName: string): string {
  if (!firstName && !lastName) return '';

  const first = removeAccents(firstName?.trim() || '').replace(/[^a-z0-9]/g, '');
  const last = removeAccents(lastName?.trim() || '').replace(/[^a-z0-9]/g, '');

  // Se houver nome e sobrenome, combine com ponto
  if (first && last) {
    return `${first}.${last}`;
  }

  // Se houver apenas um, use apenas ele
  return first || last;
}

/**
 * Valida um nome de usuário
 * Regras: apenas letras, números, underscore e ponto
 */
export function isValidUsername(username: string): boolean {
  if (!username || username.length === 0) return false;
  // Permite: letras, números, underscore (_) e ponto (.)
  return /^[a-zA-Z0-9_.]+$/.test(username);
}

/**
 * Normaliza um nome de usuário removendo espaços e caracteres especiais
 */
export function normalizeUsername(username: string): string {
  return removeAccents(username.trim())
    .replace(/[^a-z0-9_.]/g, '')
    .replace(/^[._]+|[._]+$/g, ''); // Remove pontos/underscores no início e fim
}
